<script>
import Base from "@/components/RequestDetailsForDefaultVue/RequestLog.vue";

export default {
  name: "CustomerServiceFilesRequestLog",
  extends: Base,
};
</script>
